// ** Types
import type { PaletteMode } from '@mui/material';
import type {
	AppBarType,
	FooterType,
	ContentWidth,
	AppBarVariant,
	ToastPosition,
	LayoutType
} from '@/types/contextTypes';

export type ThemeConfig = {
	templateName: string;
	layout: LayoutType;
	mode: PaletteMode;
	skin: 'default' | 'bordered';
	contentWidth: ContentWidth;
	footer: FooterType;
	routingLoader: boolean;
	navHidden: boolean;
	showMenu: boolean;
	menuTextTruncate: boolean;
	navSubItemIcon: string;
	verticalNavToggleType: 'accordion' | 'collapse';
	navcollapsed: boolean;
	navigationSize: number;
	collapsedNavigationSize: number;
	afterVerticalNavMenuContentPosition: 'fixed' | 'static';
	beforeVerticalNavMenuContentPosition: 'fixed' | 'static';
	horizontalMenuToggle: 'hover' | 'click';
	horizontalMenuAnimation: boolean;
	appBar: AppBarType;
	appBarBlur: boolean;
	appBarVariant: AppBarVariant;
	responsiveFontSizes: boolean;
	disableRipple: boolean;
	disableCustomizer: boolean;
	toastPosition: ToastPosition;
};

const themeConfig: ThemeConfig = {
	// ** Layout Configs
	templateName: 'Tischler NRW' /* App Name */,
	layout: 'default' /* default | verticalNavigation */,
	mode: 'light' as PaletteMode /* light | dark */,
	skin: 'default' /* default | bordered */,
	contentWidth: 'boxed' /* full | boxed */,
	footer: 'static' /* fixed | static | hidden */,

	// ** Routing Configs
	routingLoader: true /* true | false */,

	// ** Navigation (Menu) Configs
	navHidden: false /* true | false */,
	showMenu: true /* Default menu visibility for CMS logic */,
	menuTextTruncate: true /* true | false */,
	navSubItemIcon: 'mdi:circle-outline' /* Icon */,
	verticalNavToggleType: 'accordion' /* accordion | collapse /*! Note: This is for Vertical navigation menu only */,
	navcollapsed: false /* true | false /*! Note: This is for Vertical navigation menu only */,
	navigationSize: 260 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */,
	collapsedNavigationSize: 68 /* Number in px(Pixels) /*! Note: This is for Vertical navigation menu only */,
	afterVerticalNavMenuContentPosition: 'fixed' /* fixed | static */,
	beforeVerticalNavMenuContentPosition: 'fixed' /* fixed | static */,
	horizontalMenuToggle: 'hover' /* click | hover /*! Note: This is for Horizontal navigation menu only */,
	horizontalMenuAnimation: true /* true | false */,

	// ** AppBar Configs
	appBar: 'fixed' /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */,
	appBarBlur: true /* true | false */,
	appBarVariant: null /* light | dark | null /*! Note: Used for CMS Hero sync */,

	// ** Other Configs
	responsiveFontSizes: true /* true | false */,
	disableRipple: false /* true | false */,
	disableCustomizer: false /* true | false */,
	toastPosition: 'top-right' /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */
};

export default themeConfig;
